<script lang="ts" setup>
import { type CSSProperties, computed, nextTick, onMounted, ref, watch } from 'vue'

import Iconify from '@purge-icons/generated'

defineOptions({ name: 'SdIconifyIcon' })

const props = defineProps({
    name  : { type: String                 },
    size  : { type: Number, default: 16    },
    color : { type: String                 },
    inline: { type: Boolean, default: true },
})

const iconStyle$ = computed(() => {
    const styles: CSSProperties = {
        display   : 'inline-block',
        lineHeight: '1em',
        width     : '1em',
        height    : '1em',
    }

    if (props.size)
        styles.fontSize = `${props.size}px`

    if (props.color)
        styles.color = props.color

    return styles
})

const spanRef = ref<HTMLElement | null>(null)
const updateIcon = async() => {
    const el = spanRef.value
    if (!el)
        return

    const iconName = props.name
    if (!iconName)
        return

    await nextTick()

    /** 内容需要清空, 通过 v-if 切换时会导致重复渲染 */
    const svg = Iconify.renderSVG(iconName, {})
    if (!svg) {
        const span = document.createElement('span')

        span.className      = 'iconify'
        span.dataset.icon   = iconName
        span.dataset.inline = String(props.inline)

        el.textContent = ''
        el.appendChild(span)
    }
    else {
        el.textContent = ''
        el.appendChild(svg)
    }
}

// 监听图标变化，更新icon
watch(() => props.name, updateIcon, { flush: 'post' })

onMounted(updateIcon)

</script>

<template>
    <span ref="spanRef" class="sd-icon sd-iconify-icon" :style="iconStyle$" />
</template>
